import { createSelector, createSlice } from '@reduxjs/toolkit';
import { queryApi } from 'app/apis/queryApi';
import { RootState } from 'app/store';
import { PURGE } from 'redux-persist';

const defaultSite = {
  id: '',
  label: '',
  currency: undefined
};

const initialState: {
  siteId: string;
  siteLabel: string;
  currency?: string;
} = {
  siteId: defaultSite.id,
  siteLabel: defaultSite.label,
  currency: defaultSite.currency
};

const selectedSiteSlice = createSlice({
  name: 'selectedSite',
  initialState,
  reducers: {
    selectSite: (state, { payload }) => {
      state.siteId = payload.id;
      state.siteLabel = payload.label;
      state.currency = payload.currency ? payload.currency : undefined;
    },
    clearSites: (state) => {
      state.currency = '';
      state.siteId = '';
      state.siteLabel = '';
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
    builder.addMatcher(
      queryApi.endpoints.getSites.matchFulfilled,
      (state, { payload }) => {
        if (state.siteId === '' && payload.length > 0) {
          state.siteId = payload[0].id;
          state.siteLabel = payload[0].label;
          state.currency = payload[0].currency
            ? payload[0].currency
            : undefined;
        }
      }
    );
  }
});

const selectSelf = (state: RootState) => state.selectedSite;

export const selectSiteId = createSelector(selectSelf, (state) => state.siteId);

export const selectSiteLabel = createSelector(
  selectSelf,
  (state) => state.siteLabel
);

const { actions, reducer } = selectedSiteSlice;

export const { selectSite, clearSites } = actions;

export default reducer;
